function getKeys () {
  return [
    {
      key: 'tenantTeam',
      initValue: {},
    },
    {
      key: 'tenantTeamPermissions',
      initValue: [],
    },
    {
      key: 'tenantTeamSkills',
      initValue: [],
    },
    {
      key: 'tenantTeamTenantUsers',
      initValue: [],
    },
    {
      key: 'tenantTeamTenantUserSkills',
      initValue: [],
    },
  ];
}

const getDefaultState = () => {
  return {
    data: getKeys().reduce((result, elem) => {
      result[elem.key] = elem.initValue;
      return result;
    }, {}),
    loaded: getKeys().reduce((result, elem) => {
      result[elem.key] = false;
      return result;
    }, {}),
    skillIdToTenantUserIds: {},
    viewOnly: true,
  };
};

const teamup = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    loaded: state => key => {
      return state.loaded[key];
    },
    viewOnly: state => {
      return this.viewOnly;
    },
  },
  mutations: {
    clear (state, key) {
      state.loaded[key] = false;
      state.data[key] = getKeys().filter(elem => elem.key === key)[0].initValue;
    },
    delete (state, { key, data }) {
      const index = state.data[key].findIndex(obj => obj.id === data.id);
      if (index < 0) {
        return;
      }
      state.data[key].splice(index, 1);
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    isViewOnly (state) {
      state.viewOnly = true;
    },
    isNotViewOnly (state) {
      state.viewOnly = false;
    },
    push (state, { key, data }) {
      const index = state.data[key].findIndex(obj => obj.id === data.id);
      if (index >= 0) {
        return;
      }
      state.data[key].splice(0, 0, data);
    },
    set (state, { key, data }) {
      state.data[key] = data;
      state.loaded[key] = true;
    },
    update (state, { key, data }) {
      const index = state.data[key].findIndex(obj => obj.id === data.id);
      if (index < 0) {
        return;
      }
      state.data[key].splice(index, 1, data);
    },
  },
};

export default teamup;
